import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import ModalMenu from "../../components/Modal/ModalMenu";
import ModalSearch from "../../components/Modal/ModalSearch";
import CalculatorComponent from "../../components/Swych/CalculatorComponent";

const Calculator = () => {
    return (
        <div className="main">
            <Header />
            <CalculatorComponent/>
            <Footer />
            <ModalSearch />
            <ModalMenu />
        </div>
    )

}
export default Calculator;